import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { Avatar, ListItem } from 'material-ui';
import QuestionAnswerIcon from 'material-ui/svg-icons/action/question-answer';
import withTranslation from '../../../hoc/withTranslation';
import { QUIZ_PAGE } from '../../../constants/routes';
import style from '../../../styles/styles';

export class QuizItem extends React.Component {

    static propTypes = {
        quiz: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
    };

    renderPicture() {
        let quiz = this.props.quiz;
        if (quiz.picture && quiz.picture.length > 0) {
            return <Avatar src={quiz.picture} style={style.image.cover} />;
        }
        return <Avatar icon={<QuestionAnswerIcon />} />;
    }

    render() {
        const {
            quiz,
            app,
            t
        } = this.props;
        return (
            <Link
                to={
                    QUIZ_PAGE
                        .replace(':appId', app.id)
                        .replace(':quizId', quiz.id)
                }
            >
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderPicture()}
                    primaryText={
                        <div>
                            {quiz.name || t('module.quiz.untitled_quiz')}
                        </div>
                    }
                    disableKeyboardFocus={true}
                >
                </ListItem>
            </Link>
        );
    }
}

export default muiThemeable()(withTranslation(QuizItem));



// WEBPACK FOOTER //
// src/components/quiz/QuizItem/QuizItem.js